/* Conversational Search — vehicle dataset
 * Compact year/make/model data for natural-language query parsing.
 * Covers the top vehicles for Turbochargedracing's audience.
 */
window.TCR_VEHICLES = (function () {
  var MAKES = {
    ford:      { name: "Ford",      aliases: ["ford"] },
    chevrolet: { name: "Chevrolet", aliases: ["chevrolet", "chevy", "chev"] },
    jeep:      { name: "Jeep",      aliases: ["jeep"] },
    gmc:       { name: "GMC",       aliases: ["gmc"] },
    ram:       { name: "Ram",       aliases: ["ram", "dodge ram"] },
    dodge:     { name: "Dodge",     aliases: ["dodge"] },
    toyota:    { name: "Toyota",    aliases: ["toyota"] },
    honda:     { name: "Honda",     aliases: ["honda"] },
    nissan:    { name: "Nissan",    aliases: ["nissan"] },
    bmw:       { name: "BMW",       aliases: ["bmw"] }
  };

  // modelKey: { make, name, aliases[], years:[start,end] }
  var MODELS = {
    "f-150":     { make: "ford", name: "F-150", aliases: ["f-150", "f150", "f 150"], years: [1980, 2026] },
    "f-250":     { make: "ford", name: "F-250 Super Duty", aliases: ["f-250", "f250", "f 250", "super duty", "superduty"], years: [1999, 2026] },
    "mustang":   { make: "ford", name: "Mustang", aliases: ["mustang"], years: [1964, 2026] },
    "bronco":    { make: "ford", name: "Bronco", aliases: ["bronco"], years: [1966, 2026] },
    "ranger":    { make: "ford", name: "Ranger", aliases: ["ranger"], years: [1983, 2026] },
    "explorer":  { make: "ford", name: "Explorer", aliases: ["explorer"], years: [1991, 2026] },
    "expedition":{ make: "ford", name: "Expedition", aliases: ["expedition"], years: [1997, 2026] },
    "silverado": { make: "chevrolet", name: "Silverado 1500", aliases: ["silverado", "silverado 1500", "silverado1500"], years: [1999, 2026] },
    "colorado":  { make: "chevrolet", name: "Colorado", aliases: ["colorado"], years: [2004, 2026] },
    "camaro":    { make: "chevrolet", name: "Camaro", aliases: ["camaro"], years: [1967, 2024] },
    "corvette":  { make: "chevrolet", name: "Corvette", aliases: ["corvette", "vette"], years: [1953, 2026] },
    "tahoe":     { make: "chevrolet", name: "Tahoe", aliases: ["tahoe"], years: [1995, 2026] },
    "suburban":  { make: "chevrolet", name: "Suburban", aliases: ["suburban"], years: [1935, 2026] },
    "wrangler":  { make: "jeep", name: "Wrangler", aliases: ["wrangler", "wrangler jk", "wrangler jl", "wrangler tj", "jk", "jl"], years: [1987, 2026] },
    "gladiator": { make: "jeep", name: "Gladiator", aliases: ["gladiator"], years: [2020, 2026] },
    "grand-cherokee": { make: "jeep", name: "Grand Cherokee", aliases: ["grand cherokee", "grandcherokee"], years: [1993, 2026] },
    "cherokee":  { make: "jeep", name: "Cherokee", aliases: ["cherokee"], years: [1974, 2026] },
    "sierra":    { make: "gmc", name: "Sierra 1500", aliases: ["sierra", "sierra 1500", "sierra1500"], years: [1999, 2026] },
    "canyon":    { make: "gmc", name: "Canyon", aliases: ["canyon"], years: [2004, 2026] },
    "yukon":     { make: "gmc", name: "Yukon", aliases: ["yukon"], years: [1992, 2026] },
    "ram-1500":  { make: "ram", name: "1500", aliases: ["ram 1500", "ram1500", "1500"], years: [1994, 2026] },
    "ram-2500":  { make: "ram", name: "2500", aliases: ["ram 2500", "ram2500", "2500"], years: [1994, 2026] },
    "charger":   { make: "dodge", name: "Charger", aliases: ["charger"], years: [1966, 2026] },
    "challenger":{ make: "dodge", name: "Challenger", aliases: ["challenger"], years: [1970, 2026] },
    "durango":   { make: "dodge", name: "Durango", aliases: ["durango"], years: [1998, 2026] },
    "tacoma":    { make: "toyota", name: "Tacoma", aliases: ["tacoma"], years: [1995, 2026] },
    "tundra":    { make: "toyota", name: "Tundra", aliases: ["tundra"], years: [2000, 2026] },
    "4runner":   { make: "toyota", name: "4Runner", aliases: ["4runner", "4 runner", "forerunner"], years: [1984, 2026] },
    "supra":     { make: "toyota", name: "Supra", aliases: ["supra"], years: [1978, 2026] },
    "gr86":      { make: "toyota", name: "GR86", aliases: ["gr86", "86", "gt86"], years: [2012, 2026] },
    "civic":     { make: "honda", name: "Civic", aliases: ["civic"], years: [1973, 2026] },
    "accord":    { make: "honda", name: "Accord", aliases: ["accord"], years: [1976, 2026] },
    "370z":      { make: "nissan", name: "370Z", aliases: ["370z", "370 z"], years: [2009, 2020] },
    "frontier":  { make: "nissan", name: "Frontier", aliases: ["frontier"], years: [1998, 2026] },
    "titan":     { make: "nissan", name: "Titan", aliases: ["titan"], years: [2004, 2024] }
  };

  // Popular part categories for quick chips (matched to store collections)
  var PART_CHIPS = [
    { label: "Tonneau Covers", q: "tonneau cover" },
    { label: "Exhaust", q: "exhaust system" },
    { label: "Air Intakes", q: "cold air intake" },
    { label: "Suspension", q: "suspension lift kit" },
    { label: "Brakes", q: "brake pads" },
    { label: "Lighting", q: "led headlights" },
    { label: "Wheels", q: "wheels" },
    { label: "Motor Oil", q: "motor oil" }
  ];

  return { MAKES: MAKES, MODELS: MODELS, PART_CHIPS: PART_CHIPS };
})();
